/**
 * 异步函数封装
 * @param fn
 * @returns
 */
export const wrapAsyncFunction =  <ARGS extends unknown[]>(
  fn: (...args: ARGS) => Promise<unknown>,
): ((...args: ARGS) => void) => (...args) => {
    fn(...args);
  };
